import styled from 'styled-components';

/* eslint-disable consistent-return */
var Suffix = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-126c671-0"
})(["height:2.16rem;align-items:center;display:flex;", ""], function (props) {
  if (props.label && !props.withFeedback) {
    return "\n      padding-top: 1.2rem;\n      ";
  }

  if (!props.label && !props.withFeedback) {
    return "\n      padding-top: 1rem;\n      ";
  }
});
var SuffixInputWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-126c671-1"
})(["padding-right:0.32rem;flex:1;"]);
var SuffixWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-126c671-2"
})(["display:flex;align-items:center;"]);

export default Suffix;
export { Suffix, SuffixInputWrapper, SuffixWrapper };
//# sourceMappingURL=Suffix.js.map
